import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PurchasesActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPurchase = (data): any => action(types.CREATE_PURCHASE_REQUESTED, data);

export const createCreditCardAndPurchase = (data): any => action(types.CREATE_CREDIT_CARD_AND_PURCHASE_REQUESTED, data);

export const updatePurchase = (data): any => action(types.UPDATE_PURCHASE_REQUESTED, data);

export const deletePurchase = (purchaseId): any => action(types.UPDATE_PURCHASE_REQUESTED, purchaseId);

export const getPurchase = (purchaseId): any => action(types.GET_PURCHASE_REQUESTED, purchaseId);

export const getAllPurchases = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PURCHASES_REQUESTED, { pagination, compile });

export const selectPurchase = (purchaseId): any => action(types.SELECT_PURCHASE_REQUESTED, {
  currentPurchaseId: purchaseId,
});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPurchasePending: (payload): any => action(types.CREATE_PURCHASE_PENDING, payload),
  createPurchaseSuccess: (response): any => {
    const purchase = response.entities.purchases[response.result];
    if (purchase.status === 'successful') {
      history.push(`/payment/${purchase.paymentCollection.id}/receipt`);
    } else if (purchase.status === 'failed') {
      return action(types.CREATE_PURCHASE_FAIL, {
        backendErrors: {
          message:
            purchase.errorDescription
            || 'Card transaction failed, please try again.',
        },
      });
    }
    return action(types.CREATE_PURCHASE_SUCCESS, {
      purchasesById: response.entities.purchases,
      currentPurchaseId: response.result,
    });
  },
  createPurchaseFailed: (error): any => action(types.CREATE_PURCHASE_FAIL, { backendErrors: error }),
  createCreditCardAndPurchasePending: (): any => action(types.CREATE_CREDIT_CARD_AND_PURCHASE_PENDING),
  createCreditCardAndPurchaseSuccess: (): any => action(types.CREATE_CREDIT_CARD_AND_PURCHASE_SUCCESS),
  createCreditCardAndPurchaseFailed: (): any => action(types.CREATE_CREDIT_CARD_AND_PURCHASE_FAIL),
  updatePurchasePending: (payload): any => action(types.UPDATE_PURCHASE_PENDING, payload),
  updatePurchaseSuccess: (response): any => action(types.UPDATE_PURCHASE_SUCCESS, {
    purchasesById: response.entities.purchases,
    currentPurchaseId: response.result,
  }),
  updatePurchaseFailed: (error): any => action(types.UPDATE_PURCHASE_FAIL, { backendErrors: error }),
  deletePurchasePending: (): any => action(types.UPDATE_PURCHASE_PENDING, {}),
  deletePurchaseSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPurchaseId: null });
    history.push('/purchases');

    return action(types.DELETE_PURCHASE_SUCCESS, {
      currentPurchaseId: response,
    });
  },
  getPurchasePending: (): any => action(types.GET_PURCHASE_PENDING, {}),
  getPurchaseSuccess: (response): any => action(types.GET_PURCHASE_SUCCESS, {
    purchasesById: response.entities.purchases,
    currentPurchaseId: response.result,
  }),
  getPurchaseFailed: (error): any => action(types.GET_PURCHASE_FAIL, { backendErrors: error }),
  deletePurchaseFailed: (error): any => action(types.UPDATE_PURCHASE_FAIL, { backendErrors: error }),
  getAllPurchasesPending: (pagination): any => action(types.GET_ALL_PURCHASES_PENDING, { pagination }),
  getAllPurchasesSuccess: (response, meta): any => action(types.GET_ALL_PURCHASES_SUCCESS, {
    purchasesById: response.entities.purchases,
    purchaseIds: response.result,
    meta,
  }),
  getAllPurchasesFailed: (error): any => action(types.GET_ALL_PURCHASES_FAIL, { backendErrors: error }),
};

export default null;
